module.exports = __webpack_public_path__ + "static/media/desk-chair.4bb79f27.svg";